module.exports = __webpack_public_path__ + "static/media/Room6.2cb1ed09.PNG";